import { IBookingTicket } from "./IBooking";
import { BookingTeamsStatus } from "../teams/teams";
import { IBookingRetail } from "./IBooking";
import {
  DatePeriod,
  OptionTypes,
  SortingDirections,
  SortingOptions,
} from "@/app-search/enums/enums";

export enum OrderTableColumns {
  REFERENCE,
  CUSTOMER,
  DATE_OF_VISIT,
  QUANTITY,
  TICKETS,
  RETAILS,
  ADDONS,
  CREATION_DATE,
  PAYMENT_STATUS,
  SELLER,
  CHANNEL,
  TOTAL_VALUE,
  TEAMS,
}

export interface IOrderTableColumn {
  id: OrderTableColumns;
  label: string;
  enabled: boolean;
}

export interface IDateFilterParams {
  from?: string;
  to?: string;
}

export interface IDateOfVisitFilter {
  params: IDateFilterParams;
  type: OptionTypes;
  startDate?: string;
  startTime?: string;
  startDate2?: string;
  startTime2?: string;
  isAfterNow?: boolean;
  selectedDateShortcut?: DatePeriod;
}

export interface IOrderState {
  orderTableConfig: IOrderTableColumn[];
  dateOfVisitFilter: IDateOfVisitFilter | null;
  selectedSortingOption: SortingOptions;
  selectedSortingDirection: SortingDirections;
}

export interface IParsedOrder {
  id: string;
  reference: string;
  createdAt: string;
  sellerFullName: string;
  totalValue: string;
  bookingState?: string;
  bookingPaymentStatus: string;
  bookingSource: string;
  bookingChannel: string;
  customerFullName: string;
  requireTeams: boolean;
  teamsStatus: BookingTeamsStatus | null;
  bookingTickets: IBookingTicket[];
  bookingRetails: IBookingRetail[];
  firstStartDate: string;
  quantity: number;
}
